import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import BooksExemplarsPage from "./BooksExemplarsPage";

const CallViewBook = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <BooksExemplarsPage id={match.params.id} context={"view"} type={"BOOK"}/>      
    </div>
  );
}

export default CallViewBook;